import React from 'react';
import Message from '../Base';
import MessageContainer from './style';
const Index = (props) => {
  return <Message {...props} MessageContainer={MessageContainer} />;
};

export default Index;
